import { Button } from "@/components/button";
import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";

export function Points() {
  const { feedback, formFeedBack, selected, setFormFeedBack, setSelected } =
    useFeedbackTool();

  return feedback?.map((item) => (
    <div
      className="absolute z-[2]"
      key={item.id}
      onClick={(event) => event.stopPropagation()}
      style={{
        left: `${Number(item.x) * 100}%`,
        top: `${Number(item.y) * 100}%`,
      }}
    >
      <Button
        className={`bg-white w-5 h-7 flex justify-center items-center rounded-full text-black cursor-pointer ${item.id === selected?.id ? "bg-button-primary-bg text-white" : "bg-white text-black"}`}
        onPress={() => {
          if (formFeedBack) setFormFeedBack(null);
          if (item === selected) {
            return setSelected(null);
          }
          setSelected(item);
        }}
      >
        {item.id}
      </Button>
    </div>
  ));
}
